import { render, staticRenderFns } from "./mmpOfferDetail.vue?vue&type=template&id=47b0ddec&scoped=true"
import script from "./mmpOfferDetail.vue?vue&type=script&lang=js"
export * from "./mmpOfferDetail.vue?vue&type=script&lang=js"
import style0 from "./mmpOfferDetail.vue?vue&type=style&index=0&id=47b0ddec&prod&lang=css"
import style1 from "./mmpOfferDetail.vue?vue&type=style&index=1&id=47b0ddec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47b0ddec",
  null
  
)

export default component.exports